module.exports = __webpack_public_path__ + "img/ring_y_skip_0_null@3x.c1441b25.png";